<script>
import capitalize from 'lodash/capitalize'

export default {
  name: 'ProductFormStepper',
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentStep() {
      return this.$route.params.step || 'product'
    },
  },
  methods: {
    capitalize,
    isActive(step) {
      return this.currentStep === step
    },
  },
}
</script>

<template>
  <ul
    :class="$style.wrapper"
  >
    <li
      v-for="(step, index) in steps"
      :key="index"
      :class="[$style.item, {[$style.active]: isActive(step) }]"
    >
      {{ capitalize(step) }}
    </li>
  </ul>
</template>

<style lang="scss" module>
.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 27rem;
  padding: 0;
  margin: 0;
  list-style: none;
  cursor: default;
  user-select: none;
}

.item {
  position: relative;
  flex: 1 1 0%;
  padding-top: 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: #BDCCDC;
  text-align: center;

  &:before {
    position: absolute;
    top: 0;
    left: 5%;
    z-index: 1;
    width: 90%;
    height: 0.5rem;
    content: '';
    background-color: #BDCCDC;
    border: 1px solid #BDCCDC;
  }
}

.active {
  color:var(--color-primary);

  &:before {
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }

  ~ .item:before {
    background-color: transparent;
  }
}

</style>
